module.exports = __webpack_public_path__ + "img/bg5.be510f21.png";